import API from "../../api/phx";

export const applyGiftCards = async (orderId, giftCards, orderTotal) => {

    let orderTotalRemaining = Number(orderTotal).toFixed(2);

    // Loop through the gift cards and keep applying until we reach the order total.
    for (let i = 0; i < giftCards.length; i += 1) {
      const giftCard = giftCards[i];

      let amount = giftCard.balance;
      const giftCardId = giftCard.gift_card_id;

      // If the gift card is more than the amount remaining cap it.
      if (orderTotalRemaining - amount < 0) {
        amount = orderTotalRemaining;
      }

      // Update the order remaining so we don't overpay the order total.
      orderTotalRemaining -= amount;

      const data = {
        order_id: orderId,
        currency: giftCard.currency,
        amount: amount,
        description: 'checkout payment',
        gift_card_id: giftCardId,
      };

      try {
        // Need to wait to ensure payment receipt ids match up to the correct gift card.
        // eslint-disable-next-line no-await-in-loop
        API.post('/payments/gift_card', data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to apply gift card to order.', JSON.stringify(err));
      }
    }

    // Now we've applied all gift cards save the order.
    const order = await API.get(`/orders/${orderId}`);
    try {
      API.put(`/orders/${orderId}`, JSON.stringify(order.data));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to save order after gift cards applied".', err);
    }
  }